<template>
  <div>
    <div class="ui three columns grid">
      <div class="column">
        <h4 class="ui dividing header">
          Patient Information
        </h4>
        <abstractTable
          :data="patientInfo"
          :definitionTable="true"
          :definitionTableWidth="'20%'"
          :classes="'ui compact definition table'"
        >
        </abstractTable>
      </div>
      <div class="column">
        <h4 class="ui dividing header">
          Patient Physique
        </h4>
        <abstractTable
          :data="patientPhysique"
          :definitionTable="true"
          :definitionTableWidth="'20%'"
          :classes="'ui compact definition table'"
        >
        </abstractTable>
      </div>
      <div class="column">
        <h4 class="ui dividing header">
          Patient Status
        </h4>
        <abstractTable
          :data="patientStatus"
          :definitionTable="true"
          :definitionTableWidth="'35%'"
          :classes="'ui compact definition table'"
        >
        </abstractTable>
      </div>
      <div class="column"></div>
    </div>

    <h4 class="ui dividing header">
      Patient Other Information
    </h4>
    <abstractTable
      :data="patientOtherInfo"
      :definitionTable="true"
      :definitionTableWidth="'16%'"
      :classes="'ui compact definition table'"
    >
    </abstractTable>
    <div style="padding-bottom: 20px;"></div>
  </div>
</template>

<script>
export default {
  components: {
    abstractTable: require('@/components/abstract_components/AbstractTable')
      .default
  },
  props: {
    patient: { type: Object, required: true }
  },
  computed: {
    patientDetails() {
      return this.patient.patient_details &&
        this.patient.patient_details.length > 0
        ? this.patient.patient_details[0].details
          ? this.patient.patient_details[0].details
          : {}
        : {};
    },
    patientInfo() {
      return {
        id: this.patient.id,
        code: this.patient.code,
        [this.$t('name')]: this.capitalizeWords(
          this.escapeBackSlashString(this.patient.name)
        ),
        [this.$t('phone')]: !this.$auth.check('doctor')
          ? this.patient.telephone || '-'
          : '-',
        [this.$t('mobile')]: !this.$auth.check('doctor')
          ? this.patient.cell_phone || '-'
          : '-',
        [this.$t('gender')]: this.getGender(this.patient.gender),
        'Address Area':
          this.PatientAreas[this.patient.patient_area_id] || '-',
        Referrer: this.patientDetails.referrer || '-'
      };
    },
    patientPhysique() {
      return {
        [this.$t('age')]: this.getAge(this.patient.date_of_birth) || '-',
        [this.$t('weight')]: this.patient.weight,
        height: this.patientDetails.height || '-'
      };
    },
    breastfeedingValue() {
      if (this.patientDetails.breastfeeding === null) {
        return '-';
      }

      return this.patientDetails.breastfeeding
        ? `<i class="green check icon"></i>`
        : `<i class="red close icon"></i>`;
    },
    pregnantValue() {
      if (this.patientDetails.pregnant === null) {
        return '-';
      }

      return this.patientDetails.pregnant
        ? `<i class="green check icon"></i>`
        : `<i class="red close icon"></i>`;
    },
    patientStatus() {
      return {
        breast_feeding: {
          html: true,
          value: this.breastfeedingValue
        },
        pregnant: {
          html: true,
          value: this.pregnantValue
        },
        height: this.patientDetails.height || '-'
      };
    },
    patientOtherInfo() {
      return {
        'medical condition': this.patientDetails.medical_condition || '-',
        medication: this.patientDetails.medication || '-',
        note: this.patientDetails.note || this.patientDetails.exercise || '-'
      };
    }
  }
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/patients/patient_log_componenets/PatientInfo.vue